<template>
    <div class="px-3 py-2">
        <v-form
            ref="forcar"
            lazy-validation
        >
            <b-sidebar id="editCarNewCard" lazy aria-labelledby="sidebar-no-header-title" no-header backdrop width="80rem" style="direction:ltr" right title="إضافة ملاحظة" shadow >
                <template #default="{ hide }">
                    <div class="m-1 text-start" style="direction:rtl">
                        <div style="width:120px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                        <span>{{lang.add_new_card}}</span>
                        </div>
                        <div @click="hide" id="hideeditCarNewCard" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                            <span>{{lang.close}}</span>
                        </div>
                    </div>
                <v-divider></v-divider>
                <v-row style="direction:rtl" class="m-2">
                    <v-col cols="12">
                        <v-row>
                            <v-col cols="12" md="3">
                                <label>{{ lang.company_name }}</label>
                                <b-form-select class="selborder" v-model="customer_id" :options="customersList"/>
                            </v-col>
                            <v-col cols="12" md="3">
                                <label>{{ lang.technical }}</label>
                                <b-form-select class="selborder" v-model="card_supervisor" :options="usersList"/>
                            </v-col>
                            <v-col cols="12" md="3">
                                <label>{{ lang.date }}</label>
                                <b-form-input type="date" class="inborder" v-model="card_date" />
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12">
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="text-center backBlack">{{ lang.plate_number }}</th>
                                    <th class="text-center backBlack">{{ lang.brand }}</th>
                                    <th class="text-center backBlack">{{ lang.model }}</th>
                                    <th class="text-center backBlack">{{ lang.car_year }}</th>
                                    <th class="text-center backBlack">{{ lang.color }}</th>
                                    <th class="text-center backBlack">{{ lang.vin }}</th>
                                    <th class="text-center backBlack">{{ lang.engine_meter }}</th>
                                    <th class="text-center backBlack">{{ lang.action }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in cars" :key="index">
                                    <td>{{ item.plate_number }}</td>
                                    <td>{{ item.brand }}</td>
                                    <td>{{ item.model }}</td>
                                    <td>{{ item.car_year }}</td>
                                    <td>{{ item.color }}</td>
                                    <td>{{ item.vin }}</td>
                                    <td>{{ item.engine_meter }} </td>
                                    <td style="cursor:pointer;margin-left: 5px;width:80px;background:red;border-bottom:2px solid #fff !important;border-top:2px solid #fff !important;">
                                        <div class="viewBTN" style="background:red !important" @click="deleteCar(index)">{{lang.delete}}</div>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>
                                        <b-form-input class="inborder" v-model="newrow.plate_number" />
                                    </th>
                                    <th>
                                        <b-form-input class="inborder" v-model="newrow.brand" />
                                    </th>
                                    <th>
                                        <b-form-input class="inborder" v-model="newrow.model" />
                                    </th>
                                    <th>
                                        <b-form-input class="inborder" v-model="newrow.car_year" />
                                    </th>
                                    <th>
                                        <b-form-input class="inborder" v-model="newrow.color" />
                                    </th>
                                    <th>
                                        <b-form-input class="inborder" v-model="newrow.vin" />
                                    </th>
                                    <th><b-form-input class="inborder" v-model="newrow.engine_meter" /></th>
                                    <td style="cursor:pointer;margin-left: 5px;width:80px;background:blue;border-bottom:2px solid #fff !important;border-top:2px solid #fff !important;">
                                        <div class="viewBTN" @click="addCar()">{{lang.add}}</div>
                                    </td>
                                </tr>
                            </tfoot>
                        </v-simple-table>
                    </v-col>
                    <v-col cols="12">
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th class="text-center backBlack" style="width:100px;">{{ lang.plate_number }}</th>
                                    <th class="text-center backBlack">{{ lang.item_code }}</th>
                                    <th class="text-center backBlack">{{ lang.item_name }}</th>
                                    <th class="text-center backBlack" style="width:70px;">{{ lang.qtty }}</th>
                                    <th class="text-center backBlack" style="width:100px;">{{ lang.unit }}</th>
                                    <th class="text-center backBlack" style="width:100px;">{{ lang.item_price }}</th>
                                    <th class="text-center backBlack" style="width:100px;">{{ lang.total }}</th>
                                    <th class="text-center backBlack" style="width:100px;">{{ lang.vat }}</th>
                                    <th class="text-center backBlack" style="width:100px;">{{ lang.ftotal }}</th>
                                    <th class="text-center backBlack" style="width:70px;">{{ lang.action }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in itemss" :key="index">
                                    <td>{{ item.plate_number }}</td>
                                    <td>{{ item.item_code }}</td>
                                    <td>{{ item[`item_name${lang.langname}`] }}</td>
                                    <td>
                                        <b-form-input class="inborder" v-model="itemss[index].qtty" @change="calcME(index)" />
                                    </td>
                                    <td>{{ item.units[`name${lang.langname}`] }}</td>
                                    <td><b-form-input class="inborder" v-model="itemss[index].price" @change="calcME(index)" /></td>
                                    <td><b-form-input class="inborder" readonly v-model="itemss[index].total" /></td>
                                    <td><b-form-input class="inborder" readonly v-model="itemss[index].vat" /></td>
                                    <td><b-form-input class="inborder" readonly v-model="itemss[index].ftotal" /></td>
                                    <td style="cursor:pointer;margin-left: 5px;width:80px;border-bottom:2px solid #fff !important;border-top:2px solid #fff !important;">
                                        <div class="viewBTN" style="background:green !important" @click="getDefPrice(index)">السعر الافتراضي</div>
                                        <div class="viewBTN" style="background:red !important" @click="deleteROw(index)">{{lang.delete}}</div>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>
                                        <b-form-select class="selborder" v-model="itemnewrow.plate_number" :options="carsList" />
                                    </th>
                                    <th>
                                        <b-form-input class="inborder" v-model="itemnewrow.item_code" @change="getItem(itemnewrow.item_code)" />
                                    </th>
                                    <th>
                                        {{itemnewrow.item_name}}
                                    </th>
                                    <th>
                                        <b-form-input class="inborder" v-model="itemnewrow.qtty" @change="calckNew()" />
                                    </th>
                                    <th>
                                        <b-form-select class="selborder" @change="getPrice()" v-model="itemnewrow.unit_id" :options="unitsList" />
                                    </th>
                                    <th>
                                        <b-form-input class="inborder" v-model="itemnewrow.price" @change="calckNew()" />
                                    </th>
                                    <th>
                                        <b-form-input class="inborder" v-model="itemnewrow.total" readonly />
                                    </th>
                                    <th>
                                        <b-form-input class="inborder" v-model="itemnewrow.vat" readonly />
                                    </th>
                                    <th>
                                        <b-form-input class="inborder" v-model="itemnewrow.ftotal" readonly />
                                    </th>

                                    <td style="cursor:pointer;margin-left: 5px;width:80px;background:blue;border-bottom:2px solid #fff !important;border-top:2px solid #fff !important;">
                                        <div class="viewBTN" @click="addRow()">{{lang.add}}</div>
                                    </td>
                                </tr>
                            </tfoot>
                        </v-simple-table>
                    </v-col>
                </v-row>
                </template>
                <template #footer="" class="shadow">
                    <div class="d-flex text-light align-items-center px-3 py-2">
                    <b-button type="button" @click="addJobOrder()" variant="success" class="ma-2" style="width:100px;">{{lang.add}}</b-button>
                    </div>
                </template>
            </b-sidebar>
        </v-form>
    </div>
</template>

<script>
import axios from 'axios'
import {SnotifyPosition} from 'vue-snotify'
export default{
    data() {
        return {
            id: 0,
            customer_id: 0,
            card_date:  (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            items: [],
            cars: [],
            newrow: {
                plate_number: '',
                brand: '',
                model: '',
                car_year: '',
                color: '',
                vin: '',
                engine_meter: '',
            },
            itemnewrow: {
                plate_number: '',
                item_code: '',
                unit_name: '',
                unit_id: '',
                item_name: '',
                qtty: '',
                price: 0,
                total: 0,
                vat: 0,
                ftotal: 0
            },
            card_items: [],
            conditions: [],
            customers: [],
            users: [],
            card_supervisor: '',
            units:[],
            cunits: [],
            unitsList: [],
            itemss: [],
            nitem: {},
            deleted: []
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        customersList: function(){
            let t = []
            for(let i=0;i<this.customers.length;i++){
                if(this.customers[i].customer_type == 1){
                    t.push({text: this.customers[i].full_name,value:this.customers[i].id})
                }
                if(this.customers[i].customer_type == 2){
                    t.push({text: this.customers[i].company_name,value:this.customers[i].id})
                }
                if(this.customers[i].customer_type == 3){
                    t.push({text: this.customers[i].entity_name,value:this.customers[i].id})
                }
            }
            return t;
        },
        usersList: function(){
            let t = []
            for(let i=0;i<this.users.length;i++){
                t.push({text: this.users[i].full_name,value:this.users[i].id})
            }
            return t;
        },
        carsList: function(){
            let t = []
            for(let i=0;i<this.cars.length;i++){
                t.push({text: this.cars[i].plate_number,value:this.cars[i].plate_number})
            }
            return t;
        },
        platesNumber: function()
        {
            let t = [];
            for(let i=0; i<this.cars.length;i++){
                t.push({
                    text: this.cars[i][0].plate_number,
                    value: this.cars[i][0].plate_number
                })
            }
            return t;
        },
        itemsList: function()
        {
            let t = [];
            for(let i=0; i<this.items.length;i++){
                t.push({
                    text: this.items[i].item_namear,
                    value: this.items[i].id
                })
            }
            return t;
        },
        // unitsList: function()
        // {
        //     let t = [];
        //     for(let i=0; i<this.units.length;i++){
        //         t.push({
        //             text: this.units[i].namear,
        //             value: this.units[i].id
        //         })
        //     }
        //     return t;
        // }

    },
    methods: {
        getPrice(){
            for(let i=0;i<this.nitem.prices.length;i++){
                if(this.itemnewrow.unit_id == this.nitem.prices[i].unit_id){
                    this.itemnewrow.price = this.nitem.prices[i].default_price
                    this.calckNew()
                }
            }
        },
        calckNew(){
            if(this.itemnewrow.qtty == 0 || this.itemnewrow.qtty == ''){
                this.itemnewrow.qtty = 0;
            }
            if(this.itemnewrow.price == 0 || this.itemnewrow.price == ''){
                this.itemnewrow.price = 0;
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
          post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type", "getCalcVat");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append("data[qtty]",this.itemnewrow.qtty)
            post.append("data[price]",this.itemnewrow.price)

            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                if(response){
                    this.itemnewrow.total = response.data.results.data.total
                    this.itemnewrow.vat = response.data.results.data.vat
                    this.itemnewrow.ftotal = response.data.results.data.ftotal
                }
            });
        },
        getDefPrice(index){
            let item = this.itemss[index];
            this.itemss[index].price = item.prices.default_price
            this.calcME(index);
        },
        calcME(index){
            let item = this.itemss[index];
            if(item.qtty == '') item.qtty = 1
            if(item.price == '') return false;
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
          post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type", "getCalcVat");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append("data[qtty]",item.qtty)
            post.append("data[price]",item.price)

            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                if(response){
                    this.itemss[index].total = response.data.results.data.total
                    this.itemss[index].vat = response.data.results.data.vat
                    this.itemss[index].ftotal = response.data.results.data.ftotal
                }
            });
        },
        getItem(item_code){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type", "getProductInv");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append("data[item_code]",item_code)

            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                if(response){
                    this.itemnewrow.item_name = response.data.results.data[`item_name${this.lang.langname}`]
                    this.unitsList = []
                    this.nitem = response.data.results.data
                    for(let i=0;i<response.data.results.data.units.length;i++){
                        this.unitsList.push({
                            value: response.data.results.data.units[i].id,
                            text: response.data.results.data.units[i][`name${this.lang.langname}`],
                        })
                    }
                }
            });
        },
        getCarCard(id){
            this.reset();
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type", "getCardnewJop");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append("data[id]",id)
            this.id = id;
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                if(response){
                    // this.id = response.data.results.data.id;
                    this.cars = response.data.results.data.cars;
                    this.card_supervisor = response.data.results.data.card.card_supervisor;
                    this.card_date = response.data.results.data.card.card_date_;
                    this.customers[0] = response.data.results.data.customer;
                    this.customer_id = response.data.results.data.customer.id
                    this.itemss = response.data.results.data.items
                }
            })
        },
        changeUnits(){
            let t = [];
            let x = 0

            for(let i=0; i<this.items.length;i++){

                if(this.items[i].item_code == this.itemnewrow.item_code){

                    console.log(this.units[this.items[i].main_unit])
                    for(let j =0;j<this.units[this.items[i].main_unit].length;j++){
                        t.push({
                            text: this.units[this.items[i].main_unit][j].namear,
                            value: this.units[this.items[i].main_unit][j].id,
                        })
                    }
                }
            }
            this.unitsList = t;
        },
        deleteCar(index){
            this.cars.splice(index);
        },
        deleteItem(index){
            this.deleted.push(this.itemss.id)
            this.itemss.splice(index);
        },
        reset() {
            this.customer_id = 0
            this.card_date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
            this.cars = []
            this.items = []
            this.resetCarNew()
        },
        resetCarNew() {
            this.newrow = {
                plate_number: '',
                brand: '',
                model: '',
                car_year: '',
                color: '',
                vin: '',
                engine_meter: '',
            }
        },
        resetItemNew() {
            this.itemnewrow = {
                plate_number: '',
                item_code: '',
                item_name: '',
                unit_name: '',
                unit_id: '',
                qtty: '',
            }
        },
        addCar(){
            this.cars.push(this.newrow);
            this.resetCarNew();
        },
        deleteROw(index){
            this.itemss.splice(index,1)
        },
        resetAll(){
            this.contract_id =  0;
            this.job_date =   (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            this.project
        },
        updateIt(item){
            // console.log(item);
            this.contract_id = item.id;
            this.items = item.items;
            this.cars= item.cars;
        },
        getCardSettigns(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
          post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type", "getCardSettings");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append("data[id]",1)

            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                if(response){
                    this.customers = response.data.results.customers
                    this.users = response.data.results.users
                    this.items = response.data.results.items
                    this.units = response.data.results.units
                }
            })
        },
        addJobOrder(){
            if(this.cars.length == 0){
                let message = "يرجى اضافة سيارة على الاقل - Please add car";
                    this.$snotify.error(message, 'تنبيه', {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: 'موافق',
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                    // document.getElementById('addModalBTN').click()
                                }
                            },
                        ]
                    });
                    return false;
            }
            if(this.itemss.length == 0){
                let message = "يرجى اضافة صنف على الاقل - Please add item";
                    this.$snotify.error(message, 'تنبيه', {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: 'موافق',
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                    // document.getElementById('addModalBTN').click()
                                }
                            },
                        ]
                    });
                    return false;
            }
            if(this.customer_id == ''){
                let message = "يرجى اخيتار عميل - Please chose customer";
                    this.$snotify.error(message, 'تنبيه', {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: 'موافق',
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                    // document.getElementById('addModalBTN').click()
                                }
                            },
                        ]
                    });
                    return false;
            }
            if(this.card_supervisor == ''){
                let message = "يرجى اخيتار الفني - Please chose technician";
                    this.$snotify.error(message, 'تنبيه', {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: 'موافق',
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                    // document.getElementById('addModalBTN').click()
                                }
                            },
                        ]
                    });
                    return false;
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type", "editNewCarJob");
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append("data[id]",this.id)
            post.append("data[cars]",JSON.stringify(this.cars))
            post.append("data[itemss]",JSON.stringify(this.itemss))
            post.append("data[customer_id]",this.customer_id)
            post.append("data[card_date]",this.card_date)
            post.append("data[card_supervisor]",this.card_supervisor)
            post.append("data[deleted]",JSON.stringify(this.deleted))

            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                if(response){
                    let message = "تم تعديل الطلب بنجاح - Job order added";
                    this.$snotify.error(message, 'تنبيه', {
                        timeout: 1000000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: 'موافق',
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                }
                            },
                        ]
                    });
                    this.$parent.getJobs();
                    document.getElementById('hideeditCarNewCard').click()
                    return false;
                }
            })
        },
        addRow(){
            if(this.itemnewrow.plate_number == ''){
                let message = "يرجى اختيار رقم اللوحة المراد اضافة الصيانة لها";
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: 'موافق',
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                                // document.getElementById('addModalBTN').click()
                            }
                        },
                    ]
                });
                return false;
            }

            if(this.itemnewrow.item_code == ''){
                let message = "يرجى اختيار الصنف";
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: 'موافق',
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                                // document.getElementById('addModalBTN').click()
                            }
                        },
                    ]
                });
                return false;
            }
            if(this.itemnewrow.qtty == '' || this.itemnewrow.qtty == 0){
                let message = "يرجى اضافة الكمية قبل المتابعة";
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: 'موافق',
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                                // document.getElementById('addModalBTN').click()
                            }
                        },
                    ]
                });
                return false;
            }
            // // console.log("dfs",this.items);
            // for(let i=0;i<this.items;i++){
            let item = {
                id: 0,
                plate_number: this.itemnewrow.plate_number,
                item_code: this.itemnewrow.item_code,
                item_namear: this.itemnewrow.item_name,
                item_nameen: this.itemnewrow.item_name,
                qtty: this.itemnewrow.qtty,
                price: this.itemnewrow.price,
                total: this.itemnewrow.total,
                vat: this.itemnewrow.vat,
                ftotal: this.itemnewrow.ftotal,
                unit_id: this.itemnewrow.unit_id,
                prices: {},
                units: {}
            };
            for(let i=0;i<this.nitem.units.length;i++){
                if(this.nitem.units[i].id == this.itemnewrow.unit_id){
                    item.units = this.nitem.units[i]
                }
            }
            for(let i=0;i<this.nitem.prices.length;i++){
                if(this.nitem.prices[i].unit_id == this.itemnewrow.unit_id){
                    item.prices = this.nitem.prices[i]
                }
            }
            this.itemss.push(item)
            this.resetItemNew();
        }

    },
    created() {
        this.getCardSettigns();
    },
}
</script>